import { createSlice } from "@reduxjs/toolkit";

import { FINAL_PARAMETER_LIST, selectedResinList } from "./constants/IXDConstants";
import { EvalProtocolOneRegen, evalRegenInitialState } from "./IXEvaluate/constants/IXEvaluateConstant";

const objIXInitialization = {
  userID: 0,
  projectID: 0,
  caseID: 0,
  treatmentName: null,
  treatmentObjID: null,
  treatmentSeqNo: 0,
  recoveryTypeId: 0,
  recovery: 0,
  feed: 0,
  automatic: 0,
  recoveryRO: 0,
  selectedProcessID: 0,
  validDesignID: 0,
  isIXDetailsFetched: false,
  newPlant_ind: true, //flag evaluate
  evaluteExisting_ind: false,
  plant_to_Upcore_ind: false,
  evaluateExisiting_ind_RuntimeFixed: true,
  evaluateExisiting_ind_RuntimeOptimized: false,
  retrofitToUpcore_ind_RuntimeFixed: true,
  retrofitToUpcore_ind_RuntimeOptimized: false,
  trains_Online: null,
  trains_StandBy: null,
  ixSaveTrainConfigurationID: 0,
  bufferTank_ind: null,
  bypassed: 0, //bypassedfrac
  no_Buffer_Tank_ind: null,
  ixSaveVesselRegenID: 0,
  cationResin: null,
  anionResin: null,
  vessel1: null,
  vessel2: null,
  vessel3: null,
  vessel4: null,
  degasifation_ind: null,
  selectedEffluent: 0,
  effluentValue: 0,
  location: 0,
  selectedResinList: selectedResinList,
  resinSelTradeIDList: [],
  listRegenConds: [],
  listAdvRegen: [],
  ixsaveEquipmentId: 0,
  pdExtPiping: 0.1,
  pdIntDistributor: 0.05,
  effluentPressure: 1,
  tankTemperature: 25,
  backwashTowerDiameter: 0,
  sacRegenVesselDia: 0,
  sbaRegenVesselDia: 0,
  avgConductivity: null,
  edtPtConductivity: null,
  regDoseSafetyFactor: null,
  regDoseOverrun: null,
  regDoseSafetyFactor2: null,
  regDose: null,
  overAllEficiency: null,
  naturalEffect_ind: null,
  overRunComputation_ind: null,
  operatingCycle_Lenght_txt: null,
  operatingCycle_Length_Rb_ind: null,
  space_velocity_Rb_ind: null,
  space_velocity_txt: null,
  hrs_Day_ind: true,
  isPrebed: false,
  listFinalParamAdj: Array(4).fill({ ...FINAL_PARAMETER_LIST }),
  listProductQualityandregeneration: [
    {
      productQualityDoseID: 0,
      resinRegenerationID: 0,
      speciesLblNameID: 0,
      averageSpeciesVal: 0,
      endpointSpeciesVal: 0,
      averageConductivityVal: 0,
      endpointConductivityVal: 0,
      speciesTwoLblNameID: 0,
      regenerantDoseLbl1ID: 0,
      regeneratDoseVal1: 0,
      regenerantDoseLbl2ID: 0,
      regenerantDoseLbl4ID: 0,
      regenerantDoseVal2: 0,
      regenerantDoseVal3: 0,
      regenerantDoseVal4: 0,
      overAllEfficiency: 0,
      overAllComputation: 0,
      doseOptimization: 0,
      naturalEffect: 0,
      saftyFactorLbl: 0,
      saftyFactorVal: 0.95,
      speciesUnit: 0,
      volume: null,
      flowRate: null,
      time: null,
      regenerationRatio: null,
      isAverageSpeciesDefault: true,
      isEndpointSpeciesDefault: true,
    },
    {
      productQualityDoseID: 0,
      resinRegenerationID: 0,
      speciesLblNameID: 0,
      averageSpeciesVal: 0,
      endpointSpeciesVal: 0,
      averageConductivityVal: 0,
      endpointConductivityVal: 0,
      speciesTwoLblNameID: 0,
      regenerantDoseLbl1ID: 0,
      regeneratDoseVal1: 0,
      regenerantDoseLbl2ID: 0,
      regenerantDoseLbl4ID: 0,
      regenerantDoseVal2: 0,
      regenerantDoseVal3: 0,
      regenerantDoseVal4: 0,
      overAllEfficiency: 0,
      overAllComputation: 0,
      doseOptimization: 0,
      naturalEffect: 0,
      saftyFactorLbl: 0,
      saftyFactorVal: 0.95,
      speciesUnit: 0,
      volume: null,
      flowRate: null,
      time: null,
      regenerationRatio: null,
      isAverageSpeciesDefault: true,
      isEndpointSpeciesDefault: true,
    },
  ],
};
const sba = [
  {
    ResinId: 176,
    ResinName: "AmberLite™ HPR4100 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 177,
    ResinName: "AmberLite™ HPR4200 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 179,
    ResinName: "AmberLite™ HPR4580 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 180,
    ResinName: "AmberLite™ HPR4700 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 182,
    ResinName: "AmberLite™ HPR4780 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 183,
    ResinName: "AmberLite™ HPR4800 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 185,
    ResinName: "AmberLite™ HPR4811 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 186,
    ResinName: "AmberLite™ HPR550 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 196,
    ResinName: "AmberLite™ HPR9100 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 197,
    ResinName: "AmberLite™ HPR9200 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 24,
    ResinName: "AmberLite™ IRA402 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 26,
    ResinName: "AmberLite™ IRA410 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 27,
    ResinName: "AmberLite™ IRA458 Cl",
    IxionicFormId: 4,
  },
  {
    ResinId: 36,
    ResinName: "AmberLite™ IRA910 Cl",
    IxionicFormId: 4,
  },
];

const sca = [
  {
    ResinId: 165,
    ResinName: "AmberLite™ HPR1200 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 167,
    ResinName: "AmberLite™ HPR1300 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 170,
    ResinName: "AmberLite™ HPR1600 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 171,
    ResinName: "AmberLite™ HPR2000 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 172,
    ResinName: "AmberLite™ HPR252 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 173,
    ResinName: "AmberLite™ HPR2800 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 174,
    ResinName: "AmberLite™ HPR2900 H",
    IxionicFormId: 0,
  },
  {
    ResinId: 201,
    ResinName: "AmberLite™ IRC120 H",
    IxionicFormId: 0,
  },
];

const objDemineralization = [];
const objVessel = [];
const objResinData = {
  WAC: null,
  WBA: null,
  SAC: null,
  SBA: null,
  inert1: null,
  inert2: null,
  resinId1: null,
  resinId2: null,
  resinId3: null,
  resinId4: null,
};
// Per-node initial state — everything that was previously the flat slice state.
// Exported so callers can reference the shape (e.g. tests, type checks).
export const ixNodeInitialState = {
  ixInvalidData: {},
  ixdActiveTab: 1,
  data: objIXInitialization,
  evaluateExistFlag: false,
  resinName1: null,
  resinName2: null,
  resinName3: null,
  resinName4: null,
  inert1: null,
  inert2: null,
  selectedcationResign: null,
  selectedanionResign: null,
  resinData: objResinData,
  Demineralization: objDemineralization,
  vesselData: objVessel,
  activeVessels: [],
  listFinalParamAdj: Array(4).fill({ ...FINAL_PARAMETER_LIST }),
  sacData: sca,
  sbaData: sba,
  cationResinConditions: {
    regenerantID: 0,
    temperature: 0,
    temperatureID: 0,
    step1_ind: true,
    step2_ind: false,
    step3_ind: false,
    step1Con: 0,
    step2Con: 0,
    step3Con: 0,
    step1DosFrac: 0,
    step2DosFrac: 0,
    step3DosFrac: 0,
    serviceWater: null,
    backwash: null,
    chemicalID: "",
  },
  evalProtocolOneRegen: EvalProtocolOneRegen,
  evalProtocolTwoRegen: EvalProtocolOneRegen,
  evalProtocolThreeRegen: EvalProtocolOneRegen,
  anionResinConditions: {
    regenerantID: 0,
    temperature: 0,
    temperatureID: 0,
    step1_ind: true,
    step2_ind: false,
    step3_ind: false,
    step1Con: 0,
    step2Con: 0,
    step3Con: 0,
    step1DosFrac: 0,
    step2DosFrac: 0,
    step3DosFrac: 0,
    serviceWater: null,
    backwash: null,
    chemicalID: "",
  },
  thirdProtocolResinConditions: {
    regenerantID: 0,
    temperature: 0,
    temperatureID: 0,
    step1_ind: true,
    step2_ind: false,
    step3_ind: false,
    step1Con: 0,
    step2Con: 0,
    step3Con: 0,
    step1DosFrac: 0,
    step2DosFrac: 0,
    step3DosFrac: 0,
    serviceWater: null,
    backwash: null,
    chemicalID: "",
  },
  updateCationObject: {
    BDW: false,
    BFW: false,
    DW: false,
    FW: false,
  },
  updateAnionObject: {
    BDW: false,
    DW: false,
    FW: false,
    BFW: false,
  },
  updateThirdProtocolObject: {
    BDW: false,
    BFW: false,
    DW: false,
    FW: false,
  },
  updateCationRegenData: {
    vesselID: null,
    bwFrequency: null,
    bwExpansion: null,
    bwDuration: null,
    compactionDuration: null,
    regenerationVelocity: null,
    regenerationFactor: null,
    displacementFlow: null,
    displacementVolume: null,
    fatRinseRecycle: null,
    fatRinseVolume: null,
    settingDuration: null,
  },
  updateAnionRegenData: {
    vesselID: null,
    bwFrequency: null,
    bwExpansion: null,
    bwDuration: null,
    compactionDuration: null,
    regenerationVelocity: null,
    regenerationFactor: null,
    displacementFlow: null,
    displacementVolume: null,
    fatRinseRecycle: null,
    fatRinseVolume: null,
    settingDuration: null,
  },

  updateAdvCationObject: {
    bwFrequency: false,
    bwExpansion: false,
    bwDuration: false,
    compactionDuration: false,
    regenerationVelocity: false,
    regenerationFactor: false,
    displacementFlow: false,
    displacementVolume: false,
    fatRinseRecycle: false,
    fatRinseVolume: false,
    settingDuration: false,
  },
  updateAdvAnionObject: {
    bwFrequency: false,
    bwExpansion: false,
    bwDuration: false,
    compactionDuration: false,
    regenerationVelocity: false,
    regenerationFactor: false,
    displacementFlow: false,
    displacementVolume: false,
    fatRinseRecycle: false,
    fatRinseVolume: false,
    settingDuration: false,
  },
  updateAdvThirdProtocolObject: {
    bwFrequency: false,
    bwExpansion: false,
    bwDuration: false,
    compactionDuration: false,
    regenerationVelocity: false,
    regenerationFactor: false,
    displacementFlow: false,
    displacementVolume: false,
    fatRinseRecycle: false,
    fatRinseVolume: false,
    settingDuration: false,
  },
  updateCationDataAdvRegen: {},
  updateAnionDataAdvRegen: {},
  updateThirdProtocolDataAdvRegen: {},
  jsonResinData: [],
  regenerantListValue: {},
  isIXDDataUpdated: false,
  resinMappingData: null,
  showFinalParameterTab: false,
  isSaveIXDReportJson: false,
  isEvalRegenValidated: {
    protocol1Validation: false,
    protocol2Validation: false,
    regenSVProt1Validation: false,
    regenSVProt2Validation: false,
    regenSVProt3Validation: false,
  },
  resinVolumeReference: {
    prot1VolumeReference: null,
    prot2VolumeReference: null,
    prot3VolumeReference: null,
  },
  resinsDataById: {},
  retrofitUseVesselResinVolumeFlag: false,
  cationDefaultConcentration: 0,
  reCalcFpaResinObj: null,
  fpaInertCalcArr: null,
  isLastFieldOnIXScreen: false,
};

// Top-level slice state: a map of nodeId → per-node state, plus the active node id.
const initialState = {
  nodes: {},
  activeNodeId: null,
  chemicalUpdateCount: -1,
};

// Helper — returns the node, auto-initializing it if it doesn't exist yet.
// This ensures reducers work even when fetchIXDetails runs before the IXD
// component has had a chance to dispatch initializeIXNode.
const getNode = (state, nodeId) => {
  if (!nodeId) return {};
  if (!state.nodes[nodeId]) {
    state.nodes[nodeId] = ixNodeInitialState;
  }
  return state.nodes[nodeId];
};

/**
 * Reset auto-calculation default flags for both cation and anion product quality entries.
 * Called when IXSD process changes or new treatment is selected.
 * This allows auto-calculation logic to rerun on next feed data update.
 *
 * @param node - The per-node state object
 */
const resetAutoCalculationFlags = node => {
  if (!node?.data?.listProductQualityandregeneration) return;

  // Reset both cation [0] and anion [1] entries
  node.data.listProductQualityandregeneration.forEach((entry, index) => {
    if (entry) {
      node.data.listProductQualityandregeneration[index] = {
        ...entry,
        isAverageSpeciesDefault: true,
        isEndpointSpeciesDefault: true,
      };
    }
  });
};

export const IXDSlice = createSlice({
  name: "IXStore",
  initialState,
  reducers: {
    // ── Node lifecycle ────────────────────────────────────────────────────────
    initializeIXNode: (state, action) => {
      const { nodeId } = action.payload;
      if (!state.nodes[nodeId]) {
        state.nodes[nodeId] = ixNodeInitialState;
      }
    },
    setActiveIXNode: (state, action) => {
      state.activeNodeId = action.payload.nodeId;
    },
    removeIXNode: (state, action) => {
      const { nodeId } = action.payload;
      delete state.nodes[nodeId];
    },

    // ── Data / store ──────────────────────────────────────────────────────────
    // Payload convention:
    //   - Simple-assignment reducers:  { nodeId, data: <value> }
    //   - Spread-into-state reducers:  { nodeId, ...fieldsToBeMerged }
    updateIXDataStatus: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.ixInvalidData = { ...node.ixInvalidData, ...rest };
    },
    updateIXStore: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.data = rest;
      node.isIXDDataUpdated = true;
    },
    updateIXStoreData: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;

      // Detect if treatment-related fields have changed
      const treatmentChanged =
        (rest.selectedProcessID !== undefined && rest.selectedProcessID !== node.data.selectedProcessID) ||
        (rest.treatmentName !== undefined && rest.treatmentName !== node.data.treatmentName);

      // Update the data
      node.data = { ...node.data, ...rest };
      node.isIXDDataUpdated = true;

      // Reset auto-calculation flags if treatment has changed
      if (treatmentChanged) {
        resetAutoCalculationFlags(node);
      }
    },
    updateIXStoreState: (state, { payload }) => {
      const { nodeId, ...rest } = payload;
      if (!state.nodes[nodeId]) return;
      state.nodes[nodeId] = { ...state.nodes[nodeId], ...rest };
    },
    updateResinData: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.resinData = { ...node.resinData, ...rest };
    },
    updateDemineralization: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.Demineralization = data;
    },
    updateResinNames: (state, { payload }) => {
      const { nodeId, ...rest } = payload;
      if (!state.nodes[nodeId]) return;
      state.nodes[nodeId] = { ...state.nodes[nodeId], ...rest };
    },
    updateSelectedCationResin: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.selectedcationResign = data;
    },
    updateSelectedAnionResin: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.selectedanionResign = data;
    },
    updatelistFinalParamAdj: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.listFinalParamAdj = data;
    },
    updateProductQualityRegenerantDose: (state, action) => {
      const { nodeId, data, isDataUpdated } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (!node?.data) return;
      node.data.listProductQualityandregeneration = data;
      if (isDataUpdated !== false) node.isIXDDataUpdated = true;
    },
    updateProductQualityRegenerantDoseCation: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.data.listProductQualityandregeneration[0] = data;
      node.isIXDDataUpdated = true;
    },
    updateProductQualityRegenerantDoseAnion: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.data.listProductQualityandregeneration[1] = data;
      node.isIXDDataUpdated = true;
    },
    updateSelectedResin: (state, action) => {
      const { nodeId, data: selResin } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (Array.isArray(selResin)) {
        node.data.selectedResinList = selResin;
      } else {
        const colIndex = node.data.selectedResinList.findIndex(item => item.columnNo === selResin.columnNo);
        if (colIndex !== -1) {
          node.data.selectedResinList[colIndex] = {
            ...node.data.selectedResinList[colIndex],
            ...selResin,
          };
        } else {
          node.data.selectedResinList.push(selResin);
        }
        node.isIXDDataUpdated = true;
      }
    },
    updateSacData: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.sacData = data;
    },
    updateSbaData: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.sbaData = data;
    },
    updateCationInitialization: (state, action) => {
      const { nodeId, data: selectedResin } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listRegenConds.length === 0) {
        node.data.listRegenConds.unshift(selectedResin);
      } else {
        node.data.listRegenConds[0] = {
          ...node.data.listRegenConds[0],
          ...selectedResin,
        };
      }
      node.isIXDDataUpdated = true;
      // Reset auto-calculation flags when cation treatment changes
      resetAutoCalculationFlags(node);
    },
    updateCationResin: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.cationResinConditions = data;
    },
    updateAnionInitialization: (state, action) => {
      const { nodeId, data: selectedResin } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listRegenConds.length === 0) {
        node.data.listRegenConds.splice(0, 0, "");
        node.data.listRegenConds.splice(1, 0, selectedResin);
      } else {
        node.data.listRegenConds[1] = {
          ...node.data.listRegenConds[1],
          ...selectedResin,
        };
      }
      node.isIXDDataUpdated = true;
      // Reset auto-calculation flags when anion treatment changes
      resetAutoCalculationFlags(node);
    },
    updateAnionResin: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.anionResinConditions = data;
    },
    updateThirdProtocolInitialization: (state, action) => {
      const { nodeId, data: selectedResin } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listRegenConds.length <= 2) {
        node.data.listRegenConds[2] = selectedResin;
      } else {
        node.data.listRegenConds[2] = {
          ...node.data.listRegenConds[2],
          ...selectedResin,
        };
      }
      node.isIXDDataUpdated = true;
    },
    updateThirdProtocolResin: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.thirdProtocolResinConditions = data;
    },
    updateCationService: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateCationObject = data;
    },
    updateAnionService: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateAnionObject = data;
    },
    updateThirdProtocolService: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateThirdProtocolObject = data;
    },
    updateAdvCaton: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateAdvCationObject = data;
    },
    updateAdvAnion: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateAdvAnionObject = data;
    },
    updateAdvThirdProtocol: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateAdvThirdProtocolObject = data;
    },
    updateProductQualityRegenerantDoseThird: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.data.listProductQualityandregeneration[2] = data;
      node.isIXDDataUpdated = true;
    },
    updateVessel: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.vesselData = data;
    },
    updateAdvRegenCationdata: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateCationDataAdvRegen = data;
    },
    updateAdvRegenAniondata: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateAnionDataAdvRegen = data;
    },
    updateAdvRegenThirdProtocolData: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.updateThirdProtocolDataAdvRegen = data;
    },
    updateCationRegen: (state, action) => {
      const { nodeId, data: selectedRegen } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listAdvRegen.length === 0) {
        node.data.listAdvRegen.unshift(selectedRegen);
      } else {
        node.data.listAdvRegen[0] = {
          ...node.data.listAdvRegen[0],
          ...selectedRegen,
        };
      }
      node.isIXDDataUpdated = true;
    },
    updateAnionRegen: (state, action) => {
      const { nodeId, data: selectedRegen } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listAdvRegen.length === 0) {
        node.data.listAdvRegen.splice(0, 0, "");
        node.data.listAdvRegen.splice(1, 0, selectedRegen);
      } else {
        node.data.listAdvRegen[1] = {
          ...node.data.listAdvRegen[1],
          ...selectedRegen,
        };
      }
      node.isIXDDataUpdated = true;
    },
    updateThirdProtocolRegen: (state, action) => {
      const { nodeId, data: selectedRegen } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (node.data.listAdvRegen.length <= 2) {
        node.data.listAdvRegen[2] = selectedRegen;
      } else {
        node.data.listAdvRegen[2] = {
          ...node.data.listAdvRegen[2],
          ...selectedRegen,
        };
      }
      node.isIXDDataUpdated = true;
    },
    updateResinDropDownData: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.jsonResinData = data;
    },
    updateRegenerantList: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.regenerantListValue = data;
    },
    setIXDUpdate: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isIXDDataUpdated = data;
    },
    setIxdActiveTab: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.ixdActiveTab = data;
    },
    setValidDesignID: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.data.validDesignID = data;
    },
    setResinMappingData: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.resinMappingData = data;
    },
    updateShowFinalParameterTab: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.showFinalParameterTab = data;
    },
    updateFlagIsSaveIXDReportJson: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isSaveIXDReportJson = data;
    },
    updateIXDetailsFetched: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isIXDetailsFetched = data;
    },
    updateChemicalUpdatesCount: state => {
      state.chemicalUpdateCount = state.chemicalUpdateCount + 1;
    },
    resetIXData: (state, action) => {
      const { nodeId } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isIXDetailsFetched = false;
      node.cationDefaultConcentration = 0;
      node.ixInvalidData = {};
    },
    resetAllIXNodes: state => {
      state.nodes = {};
      state.activeNodeId = null;
      state.chemicalUpdateCount = -1;
    },
    updateEvalProtocolRegen: (state, action) => {
      const { nodeId, protocolKey, updatedData } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      if (
        protocolKey === "evalProtocolOneRegen" ||
        protocolKey === "evalProtocolTwoRegen" ||
        protocolKey === "evalProtocolThreeRegen"
      ) {
        node[protocolKey] = {
          ...node[protocolKey],
          ...updatedData,
          regenerantDose: {
            ...node[protocolKey]?.regenerantDose,
            ...(updatedData.regenerantDose || {}),
          },
        };
      }
    },
    updateEvalValidationFlag: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isEvalRegenValidated = { ...node.isEvalRegenValidated, ...rest };
    },
    resetEvalValidationFlag: (state, action) => {
      const { nodeId } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isEvalRegenValidated = evalRegenInitialState;
    },
    updateResinVolumeReference: (state, action) => {
      const { nodeId, ...rest } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.resinVolumeReference = { ...node.resinVolumeReference, ...rest };
    },
    updateResinsDataById: (state, action) => {
      const { nodeId, id, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.resinsDataById[id] = data;
    },
    updateEnableRetrofitVessleResinVolume: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.retrofitUseVesselResinVolumeFlag = data;
    },
    updateCationDefaultConcentration: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.cationDefaultConcentration = data;
    },
    updateReCalcFpaResinObj: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.reCalcFpaResinObj = data;
    },
    updatefpaInertCalcArr: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.fpaInertCalcArr = data;
    },
    setIsLastFieldOnIXScreen: (state, action) => {
      const { nodeId, data } = action.payload;
      const node = getNode(state, nodeId);
      if (!node) return;
      node.isLastFieldOnIXScreen = data;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  initializeIXNode,
  setActiveIXNode,
  removeIXNode,
  updateIXDataStatus,
  updateIXStore,
  updateIXStoreState,
  updateResinData,
  updateDemineralization,
  updateSelectedCationResin,
  updateSelectedAnionResin,
  updatelistFinalParamAdj,
  updateSelectedResin,
  updateSacData,
  updateSbaData,
  updateCationInitialization,
  updateCationResin,
  updateAnionResin,
  updateAnionInitialization,
  updateThirdProtocolInitialization,
  updateThirdProtocolResin,
  updateThirdProtocolService,
  updateThirdProtocolRegen,
  updateAdvRegenThirdProtocolData,
  updateVessel,
  updateCationService,
  updateAnionService,
  updateDisabledResinData,
  updateProductQualityRegenerantDose,
  updateRegenerant,
  updateAdvRegenCationdata,
  updateAdvRegenAniondata,
  updateCationRegen,
  updateAnionRegen,
  updateAdvCaton,
  updateAdvAnion,
  updateAdvThirdProtocol,
  updateProductQualityRegenerantDoseThird,
  updateJsonResin,
  updateResinDropDownData,
  updateRegenerantList,
  updateAfterReportChemDoseData,
  updateAfterReportOverRunDoseData,
  updateProductQualityRegenerantDoseCation,
  updateProductQualityRegenerantDoseAnion,
  updateChemicalUpdatesCount,
  setIXDUpdate,
  setIxdActiveTab,
  setValidDesignID,
  updateResinArrangement,
  setResinMappingData,
  updateShowFinalParameterTab,
  updateFlagIsSaveIXDReportJson,
  isIXDetailsFetched,
  updateIXDetailsFetched,
  resetIXData,
  updateIXStoreData,
  updateResinNames,
  updateEvalProtocolRegen,
  updateEvalValidationFlag,
  resetEvalValidationFlag,
  updateResinVolumeReference,
  updateResinsDataById,
  updateEnableRetrofitVessleResinVolume,
  updateCationDefaultConcentration,
  updateReCalcFpaResinObj,
  updatefpaInertCalcArr,
  setIsLastFieldOnIXScreen,
  resetAllIXNodes,
} = IXDSlice.actions;

export default IXDSlice.reducer;
